
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ServiceInterceptor } from './services/interceptor';
import { SignalrService } from './services/signalr.service';


export const httpInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS, useClass: ServiceInterceptor, multi: true
  },
];

export function getData() {
  return window["avbobconnect"];
}

export const signalrProviders = [
  {
    useClass: SignalrService,
    deps: [SignalrService],
    multi: true,
  },
];
